import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NetworkService } from './network.service';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  isOnline = true;
  private isBrowser: boolean;

  constructor(private networkService: NetworkService, @Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {
    this.networkService.networkStatus$.subscribe((status) => {
      this.isOnline = status;
    });

    if (this.isBrowser && Capacitor.getPlatform() === 'android') {
      StatusBar.setOverlaysWebView({ overlay: true }); // ✅ FIX
      StatusBar.setStyle({ style: Style.Dark });
    }

  }
}
